/**
 * Black Friday product page (only loaded on the Black Friday version of the Product section).
 *  - Buy bar on phones: shown whenever the real "Adaugă în coș" button is off screen. Once that button has been scrolled
 *    past, the bar's button presses it, so the colour and the Measura quantity chosen on the page go to the cart; before
 *    the buy box is reached, it scrolls to the length field instead, so nobody adds 1 m without choosing.
 *  - Quick lengths: buttons under the Measura field that fill it in; the set depends on the price per metre (section
 *    setting "quick lengths"), with a line under them saying any length can be typed.
 *  - Colour swatches (Swatch King app): kept to one row that scrolls sideways, with a button that shows them all.
 */
(function () {
  function setupSticky(bar) {
    if (bar._bf) return;
    bar._bf = true;
    var section = document.getElementById("MainProduct-" + bar.dataset.bfSticky);
    if (!section) return;
    var mq = window.matchMedia("(max-width: 1024px)");
    // Looked up every time: the apps on the page (Measura, Swatch King) may redraw the form after it loads.
    function realButton() {
      return section.querySelector('.product-form__buttons button[name="add"]');
    }

    function lengthField() {
      return section.querySelector(".measura-block-entry");
    }

    var ticking = false;
    function update() {
      ticking = false;
      var real = realButton();
      var box = real && real.getBoundingClientRect();
      var offScreen = !!box && (box.bottom < 0 || box.top > window.innerHeight);
      var on = !!real && mq.matches && !real.disabled && offScreen;
      if (on === bar.classList.contains("is-on")) return;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      if (on) bar.removeAttribute("inert");
      else bar.setAttribute("inert", "");
      document.documentElement.classList.toggle("bf-sticky-on", on);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();

    bar.querySelector("[data-bf-sticky-add]").addEventListener("click", function () {
      var real = realButton();
      if (!real) return;
      var field = lengthField();
      if (field && real.getBoundingClientRect().top > window.innerHeight) {
        field.scrollIntoView({ behavior: "smooth", block: "center" });
        // Focus only with a mouse or keyboard: on a phone it would open the keyboard over the quick lengths.
        var input = field.querySelector("input");
        if (input && !window.matchMedia("(pointer: coarse)").matches) input.focus({ preventScroll: true });
        return;
      }
      real.click();
    });
  }

  // The lengths for this product's price per metre, from the section setting: one line per price, "80: 1, 1.5, 2"
  // = from 80 lei/m up (shop currency). The line with the highest price not above the product's price wins; a line
  // without "price:" counts as 0.
  function lengthsFor(setting, pricePerMetre) {
    var best = null;
    setting.split(/\n/).forEach(function (line) {
      var m = line.match(/^\s*(?:(\d+(?:\.\d+)?)\s*:)?\s*(.+)$/);
      if (!m) return;
      var from = m[1] ? parseFloat(m[1]) : 0;
      var values = m[2].split(",").map(function (v) { return parseFloat(v.trim()); }).filter(function (v) { return v > 0; });
      if (!values.length || from > pricePerMetre) return;
      if (!best || from > best.from) best = { from: from, values: values };
    });
    return best ? best.values : [];
  }

  // Free-shipping minimum for the visitor's country and currency, in that currency, from the theme setting
  // ("RON:400" or "RO:RON:400" per line; the first matching line wins, as in snippets/free-shipping-notice.liquid).
  function freeShippingMinimum(texts) {
    var lines = ((texts && texts.dataset.freeShipping) || "").split(/\n/);
    var currency = texts && texts.dataset.currency;
    var country = texts && texts.dataset.country;
    for (var i = 0; i < lines.length; i++) {
      var parts = lines[i].trim().split(":");
      if (parts.length === 2 && parts[0] === currency) return parseFloat(parts[1]);
      if (parts.length === 3 && parts[0] === country && parts[1] === currency) return parseFloat(parts[2]);
    }
    return 0;
  }

  // Quick lengths for products sold by the metre: each button writes its value in the Measura field and lets the app
  // recompute the total. Lengths above the stock Measura reports are switched off.
  function setupLengths(section) {
    var texts = document.querySelector("[data-bf-swatch-labels]");
    var entry = section.querySelector(".measura-block-entry");
    var input = entry && entry.querySelector('input[data-measurement-unit="m"]');
    if (!input) return false;
    if (entry._bfLengths) return true;
    entry._bfLengths = true;
    // Prices on the page are in the visitor's currency; the setting is in lei.
    var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    var pricePerMetre = parseFloat((texts && texts.dataset.unitPrice) || "0") / 100 / rate;
    var values = lengthsFor((texts && texts.dataset.lengths) || "", pricePerMetre);
    if (!values.length) return true;

    var row = document.createElement("div");
    row.className = "bf-lengths";
    row.setAttribute("role", "group");
    row.setAttribute("aria-label", "Lungimi rapide");
    row.style.setProperty("--bf-lengths", values.length);
    var buttons = values.map(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bf-lengths__btn";
      b.dataset.value = v;
      b.textContent = String(v).replace(".", ",") + " m";
      b.addEventListener("click", function () {
        input.value = String(v);
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        mark();
      });
      row.appendChild(b);
      return b;
    });

    function stock() {
      var pos = window.AtomicPOS && window.AtomicPOS.products && window.AtomicPOS.products[entry.dataset.measuraProductId];
      var variant = pos && pos.variants && pos.variants[pos.selectedVariantId];
      if (!variant || !variant.tracksInventory || variant.continueSellingWhenOutOfStock) return Infinity;
      return typeof variant.inventoryQuantity === "number" ? variant.inventoryQuantity : Infinity;
    }
    function mark() {
      var now = parseFloat(String(input.value).replace(",", "."));
      var max = stock();
      buttons.forEach(function (b) {
        var v = parseFloat(b.dataset.value);
        b.setAttribute("aria-pressed", v === now ? "true" : "false");
        b.disabled = v > max;
      });
      updateShipping();
    }
    // Free shipping: the shortest length that, with what is already in the cart, reaches the free-shipping minimum of
    // Theme settings > Cart (same "RON:400" / "RO:RON:400" lines as the cart's own bar) gets a small truck in its corner,
    // and a line under the buttons says it ("De la [lungime] ai livrare gratuită.", or the cart version when the cart
    // already has products, since the length then counts together with them). The cart total is read again when the
    // page comes back into view, after "Adaugă în coș" and when the cart drawer closes.
    var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';
    var minimum = freeShippingMinimum(texts);
    var unitPrice = parseFloat((texts && texts.dataset.unitPrice) || "0") / 100;
    var shipText = (texts && texts.dataset.freeShippingLabel) || "";
    var shipTextCart = (texts && texts.dataset.freeShippingLabelCart) || "";
    var cartTotal = null;
    var shipNote = document.createElement("p");
    shipNote.className = "bf-lengths__ship-note";
    shipNote.hidden = true;
    function updateShipping() {
      buttons.forEach(function (b) {
        var truck = b.querySelector(".bf-lengths__truck");
        if (truck) truck.remove();
        b.classList.remove("has-ship");
        b.removeAttribute("aria-label");
      });
      shipNote.hidden = true;
      if (!minimum || !unitPrice || cartTotal === null || !shipText) return;
      var missing = minimum - cartTotal;
      if (missing <= 0) return;
      for (var i = 0; i < buttons.length; i++) {
        var b = buttons[i];
        if (b.disabled || parseFloat(b.dataset.value) * unitPrice < missing) continue;
        var label = b.textContent;
        var truck = document.createElement("span");
        truck.className = "bf-lengths__truck";
        truck.innerHTML = TRUCK;
        b.appendChild(truck);
        b.classList.add("has-ship");
        b.setAttribute("aria-label", label + ", cu livrare gratuită");
        // The sentence, with the length in bold where the text has [lungime].
        shipNote.innerHTML = TRUCK;
        var words = document.createElement("span");
        (cartTotal > 0 && shipTextCart ? shipTextCart : shipText).split("[lungime]").forEach(function (part, j) {
          if (j > 0) {
            var strong = document.createElement("strong");
            strong.textContent = label;
            words.appendChild(strong);
          }
          words.appendChild(document.createTextNode(part));
        });
        shipNote.appendChild(words);
        shipNote.hidden = false;
        return;
      }
    }
    function readCart() {
      if (!minimum) return;
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartTotal = cart.total_price / 100; updateShipping(); })
        .catch(function () {});
    }
    readCart();
    window.addEventListener("pageshow", readCart);
    document.addEventListener("visibilitychange", function () { if (!document.hidden) readCart(); });
    var addButton = section.querySelector('.product-form__buttons button[name="add"]');
    if (addButton) addButton.addEventListener("click", function () { setTimeout(readCart, 2500); });
    var drawer = document.querySelector(".drawer--cart");
    if (drawer) {
      new MutationObserver(function () {
        if (!drawer.classList.contains("drawer--visible")) readCart();
      }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
    }

    input.addEventListener("input", mark);
    input.addEventListener("change", mark);
    entry.addEventListener("click", function () { setTimeout(mark, 0); });
    entry.insertAdjacentElement("afterend", row);
    // Under the buttons: the free-shipping line first, then the "any length" hint.
    row.insertAdjacentElement("afterend", shipNote);
    var hint = texts && texts.dataset.lengthHint;
    if (hint) {
      var note = document.createElement("p");
      note.className = "bf-lengths__hint";
      note.textContent = hint;
      shipNote.insertAdjacentElement("afterend", note);
    }
    mark();
    return true;
  }

  function watchLengths(section) {
    if (setupLengths(section)) return;
    // Measura draws its field after the page loads.
    var obs = new MutationObserver(function () {
      if (setupLengths(section)) obs.disconnect();
    });
    obs.observe(section, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  function setupSwatches(root) {
    var list = root.querySelector("variant-swatch-king ul.swatch-view");
    if (!list || list._bf) return !!list;
    var items = list.querySelectorAll(":scope > li");
    if (items.length < 2) return true;
    list._bf = true;
    list.classList.add("bf-swatch-row");
    var texts = document.querySelector("[data-bf-swatch-labels]");
    var more = (texts && texts.dataset.more) || "Toate culorile";
    var less = (texts && texts.dataset.less) || "Mai puține culori";

    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "bf-swatch-toggle";
    toggle.setAttribute("aria-expanded", "false");
    function label() {
      var open = list.classList.contains("is-open");
      toggle.textContent = open ? less : more + " (" + items.length + ")";
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }
    function fits() {
      // No button when every swatch already fits on the row.
      toggle.hidden = !list.classList.contains("is-open") && list.scrollWidth <= list.clientWidth + 2;
    }
    toggle.addEventListener("click", function () {
      list.classList.toggle("is-open");
      label();
      fits();
    });
    list.insertAdjacentElement("afterend", toggle);
    label();
    fits();
    window.addEventListener("resize", fits);

    // Bring the chosen colour into view inside the row, without moving the page.
    var chosen = list.querySelector('[aria-checked="true"], .swatch-selected');
    if (chosen) list.scrollLeft = Math.max(0, chosen.offsetLeft - list.offsetLeft - 8);
    return true;
  }

  function watchSwatches(root) {
    if (setupSwatches(root)) return;
    // The app draws its swatches after the page loads.
    var obs = new MutationObserver(function () {
      if (setupSwatches(root)) obs.disconnect();
    });
    obs.observe(root, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-bf-sticky]"), setupSticky);
    Array.prototype.forEach.call(document.querySelectorAll(".bf-product"), watchSwatches);
    Array.prototype.forEach.call(document.querySelectorAll(".bf-product"), watchLengths);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
